import React from 'react';
import { Card } from 'antd';
import { SkHeader, SkTabsBar, SkFilterBar, SkTable } from './_primitives';

/** WorkflowList — 2 tabs (workflows/templates), search, table */
const WorkflowListPageLoader = () => (
  <div className="w-full p-4 md:p-6">
    <SkHeader actions={2} />
    <Card className="shadow-sm">
      <SkTabsBar tabs={2} />
      <SkFilterBar filters={1} withButton />
      <div className="overflow-x-auto">
        <SkTable rows={8} cols={5} inCard={false} />
      </div>
    </Card>
  </div>
);

export default WorkflowListPageLoader;
